export * from "@App/graphql/queries/getBrandList"
export * from "@App/graphql/queries/getServices"
export * from "@App/graphql/queries/getGarages"
export * from "@App/graphql/queries/getGarageList"
export * from "@App/graphql/queries/getGaragePremiumServices"
export * from "@App/graphql/queries/getGarageReviews"
export * from "@App/graphql/queries/getGarageDetails"
export * from "@App/graphql/queries/getGarageDays"
export * from "@App/graphql/queries/getGarageSlots"
export * from "@App/graphql/queries/getGarageBooking"
export * from "@App/graphql/queries/getCityList"
